var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100 d-flex"},[_c('div',{staticClass:"hedge bg-secondary mx-autox",class:{
		'ml-auto':_vm.first,
		'mr-auto':_vm.last
	},style:(("width:" + _vm.width + "%"))})])}
var staticRenderFns = []

export { render, staticRenderFns }